<template>
  <div class="mdmCodeInput_style">
    <el-input ref="mdmCodeInput" v-model="values" :title="values" :placeholder="placeholder" clearable size="mini" :readonly="readonly" :disabled="disabled">
      <div slot="append">
        <el-popover
            ref="mdmCodePopover"
            popper-class="mdmCodePopover"
            placement="bottom"
            width="680"
            trigger="manual"
            v-model="mdmCodePopoverVisible"
            :key="'mdmCodePopover-' + uniqueId"
            @hide="onPopoverHide">
          <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;margin-bottom: 10px">
            <div style="width: 350px;display: flex;flex-direction: row;justify-content: flex-start;align-items: center">
              <span>选择结算单位</span>
              <el-input style="width: 250px;margin-left: 10px" v-model="searchValue" placeholder="请输入结算单位" size="mini" @keyup.enter.native="searchClick">
                <el-button slot="append" size="mini" @click="searchClick">搜索</el-button>
              </el-input>
            </div>
            <div>
              <el-button size="mini" @click="clearPopover">清除</el-button>
              <el-button size="mini" @click="closePopover">关闭</el-button>
            </div>
          </div>
          <el-table border stripe height="200" :data="tableData" v-loading="loading" @row-click="rowClick">
            <el-table-column align="center" type="index" label="序号" width="52"></el-table-column>
            <el-table-column align="center" property="companyCode" label="法人公司" width="90"></el-table-column>
            <el-table-column header-align="center" property="mdmCode" label="MDM编码" width="130"></el-table-column>
            <el-table-column header-align="center" property="customerName" label="结算单位"></el-table-column>
          </el-table>
          <d2-container-pagination isPagination="right" :total="page.total" :page_count="page.currentPage" :page_size="page.pageSize" :page_sizes="page.pageSizes" :layout="layout" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></d2-container-pagination>
          <el-button slot="reference" ref="popoverBtn" size="mini" icon="el-icon-search" @click="handleClick" title="选择结算单位" :disabled="disabled" :aria-expanded="mdmCodePopoverVisible ? 'true' : 'false'"></el-button>
        </el-popover>
      </div>
    </el-input>
    <!-- 隐藏的焦点接收器 -->
    <div class="focus-fix" tabindex="-1" ref="focusFix"></div>
  </div>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
import { fetchList } from '@/api/basic/haiercustomer'
// 结算单位选择弹框

export default {
  name: 'd2-container-popover-mdmCode',
  data () {
    return {
      values: '',
      mdmCodePopoverVisible: false,
      searchValue: '',
      uniqueId: Date.now(), // 确保每次渲染不同
      // 表格加载处理
      loading: false,
      // 表格数据源
      tableData: [],
      // 查询条件表单
      searchForm: {
        dateList: {},
        inputLike: {},
        moreList: {},
        oneList: { lockFlag: '0' }
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 50,
        pageSizes: [10, 20, 30, 40, 50],
        descs: ['update_time']
      },
      layout: 'total, prev, pager, next, sizes'
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    mdmStr: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    // 点击搜索查询点击
    searchClick () {
      this.searchForm.inputLike.customerName = this.searchValue
      this.page.total = 0
      this.page.currentPage = 1
      this.fetchData()
    },
    // 查询接口方法
    fetchData () {
      this.loading = true
      fetchList(Object.assign({
        current: this.page.currentPage,
        size: this.page.pageSize,
        descs: this.page.descs
      }, this.searchForm)).then(response => {
        this.tableData = response.data.records
        this.page.total = response.data.total
        this.page.pageSize = response.data.size
        this.page.currentPage = response.data.current
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (size) {
      this.page.pageSize = size
      this.fetchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.fetchData()
    },
    handleClick () {
      this.uniqueId = Date.now() // 重新生成key
      this.mdmCodePopoverVisible = !this.mdmCodePopoverVisible
      if (this.mdmCodePopoverVisible) {
        this.searchClick()
      }
      // 关键：手动更新定位
      this.$nextTick(() => {
        this.$refs.mdmCodePopover.updatePopper()
      })
    },
    // 关闭弹窗（点击取消按钮时调用）
    closePopover () {
      // 先设置焦点到隐藏元素
      this.$refs.focusFix.focus()
      // 关闭popover
      this.mdmCodePopoverVisible = false
      // 将焦点返回到原始按钮
      this.$nextTick(() => {
        const button = this.$refs.popoverBtn
        if (button) {
          button.$el.focus()
        }
      })
    },
    // Popover隐藏时的处理
    onPopoverHide () {
      // 将焦点返回到原始按钮
      this.$nextTick(() => {
        const button = this.$refs.popoverBtn
        if (button) {
          button.$el.focus()
        }
      })
    },
    clearPopover () {
      this.$emit('clear')
      this.mdmCodePopoverVisible = false
    },
    // 点击行
    rowClick (row) {
      this.$emit('change', row)
      this.mdmCodePopoverVisible = false
    },
    getStartValues (val) {
      if (!validatenull(this.mdmStr)) {
        let model = this.$parent.elForm.model[this.mdmStr]
        if (!validatenull(model)) {
          this.values = model
        } else {
          this.values = ''
        }
      }
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val)
    },
    value: function (val, oldVal) {
      this.values = val
    }
  },
  mounted () {
    this.getStartValues(this.value)
  }
}
</script>

<style lang="scss">
.mdmCodeInput_style {
  .el-input-group__append {
    border-left: 1px solid #DCDFE6;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 10px;
  }
}
.mdmCodePopover {
  .el-table {
    font-size: 13px;
  }
  .el-table .el-table__cell {
    padding: 4px 0;
    font-size: 13px;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-popover-mdmcode/index.vue"
}
</vue-filename-injector>
